// z-index scale for overlays on phones. Third-party floating widgets sit very
// high (the accessibility plugin's #vplugin-toggler-link uses 999999), so
// anything that slides over the page — the search panel and the sheets opened
// from it, side menus, filters — goes above them. Keep the order:
//   page widgets (999999) < search panel < sheets < popups inside sheets
export const Z_MOBILE_SEARCH_PANEL = 1000010; // mirrored in index.less
export const Z_MOBILE_SHEET = 1000100;
export const Z_MOBILE_SHEET_POPUP = 1000150; // mirrored in index.less
// The onboarding tour on phones (backdrop 1000101 … card 1000104): above the
// search panel and the sheets (so a step can spotlight what is inside the
// cart / agent / autocomplete sheet), below the sheets a step opens on top of
// them (customer, baggage — m-sheet--stacked) and below popups / toasts.
// Mirrored in OnboardingTour/b2c-onboarding-tour.styles.less.
export const Z_MOBILE_TOUR_CARD = 1000104;
